import(/* webpackMode: "eager" */ "/vercel/path0/web/src/app/admin/page.tsx");
